import axios from 'axios'
import { API } from './url'

function errMsg(e, fallback) {
  return (e.response && e.response.data && e.response.data.message) || fallback
}

export default {
  getSummary: function(success, error) {
    axios.get(API.issues.summary)
      .then(function(r) { success(r.data) })
      .catch(function(e) { error(errMsg(e, 'Failed to load summary')) })
  },

  getIssues: function(filters, success, error) {
    axios.get(API.issues.list, { params: filters })
      .then(function(r) { success(r.data) })
      .catch(function(e) { error(errMsg(e, 'Failed to load issues')) })
  },

  getById: function(id, success, error) {
    axios.get(API.issues.detail(id))
      .then(function(r) { success(r.data) })
      .catch(function(e) { error(errMsg(e, 'Failed to load issue')) })
  },

  create: function(form, success, error) {
    axios.post(API.issues.list, form)
      .then(function(r) { success(r.data) })
      .catch(function(e) { error(errMsg(e, 'Failed to create issue')) })
  },

  updateStatus: function(id, body, success, error) {
    axios.put(API.issues.updateStatus(id), body)
      .then(function(r) { success(r.data) })
      .catch(function(e) { error(errMsg(e, 'Failed to update status')) })
  },

  assign: function(id, body, success, error) {
    axios.put(API.issues.assign(id), body)
      .then(function(r) { success(r.data) })
      .catch(function(e) { error(errMsg(e, 'Failed to assign member')) })
  },

  getComments: function(id, success, error) {
    axios.get(API.issues.comments(id))
      .then(function(r) { success(r.data) })
      .catch(function(e) { error(errMsg(e, 'Failed to load comments')) })
  },

  addComment: function(id, body, success, error) {
    axios.post(API.issues.comments(id), body)
      .then(function(r) { success(r.data) })
      .catch(function(e) { error(errMsg(e, 'Failed to post comment')) })
  }
}
